import axios from 'axios';
import type { UserProfileDto } from '../dto/UserProfileDto';

export const getUserProfile = async (token: string) => {
  try {
    return await axios.get<UserProfileDto>(`/api/user/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    throw error;
  }
};

